import { parseStateCommandResponse } from "../stateCommandParser";

export function parseStateCommands(raw: string, maxAdvanceHours = 24) {
  const parsed = parseStateCommandResponse(raw, "main");
  const commands = parsed.commands.filter((command) => {
    if (command.kind !== "advanceTime" || command.hours <= maxAdvanceHours)
      return true;
    parsed.diagnostics.push({
      source: "advance_time",
      severity: "error",
      message: `时间推进超过本轮允许的 ${maxAdvanceHours} 小时`,
    });
    return false;
  });
  return {
    visible: parsed.visibleText,
    commands,
    errors: parsed.diagnostics.map((diagnostic) => diagnostic.message),
  };
}
